<template>
  <div class="lay-content">
    <lay-header></lay-header>
    <lay-body></lay-body>
  </div>
</template>

<script>
export default {
  name: 'lay-content',

  components: {
    LayHeader: resolve => {require(['@/components/Layout/LayHeader.vue'], resolve);},
    LayBody: resolve => {require(['@/components/Layout/LayBody.vue'], resolve);}
  },

  data () {
    return {
    }
  },

  computed: {

  },

  methods: {

  }
}
</script>

<style lang="less" scoped>
.lay-content {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: #0a84ff;

}
</style>

